import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgLijstAkkoord = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#ECF9EC"
      fillRule="evenodd"
      d="M10 34h20V12l-4-2-2-4H10v28"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="m24 6 2.98 2.98 2.99 2.99H24z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M22 14.5H12v-1h10zM20 17.5h-8v-1h8z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="m22.836 27.85 6.894-14.928 4.54 2.096-9.25 20.03-4.568-.064-4.62-10.79 4.596-1.968z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M33.45 22.467 28.424 32.89H23.06v-1h4.736l4.754-9.857z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgLijstAkkoord);

export default ForwardRef;
